// eslint-disable-next-line
//export const API = 'https://apicalculadorasolar.aldo.com.br/' + 'api'
export const API = window.location.protocol + "//" + '127.0.0.1:5000/api'

//export const API_WCF = 'https://www.aldo.com.br/wcf/CalculadoraSolar.svc/Locations'; 

export const API_WCF = 'http://127.0.0.1:5000/wcf'; 
